import { call, put } from "redux-saga/effects";
import * as types from "../consts";
import { postSignup, postSignupUser } from "../api";

export function* postSignupRequestSaga({ payload }: ReturnType<typeof Object>) {
  try {
    let tenant: object;
    if (payload.isUser) {
      tenant = yield call(postSignupUser, payload);
    } else {
      tenant = yield call(postSignup, payload);
    }
    yield put({ type: types.POST_CREATE_TENANT_SUCCESS, tenant });
  } catch (error) {
    yield put({ type: types.POST_CREATE_TENANT_ERROR, error });
  }
}
